import Suspense from '@/components/Suspense'
import DynamicRedirect from '@/components/DynamicRedirect'
import { CustomRouteProps } from '@/types/router'
import React from 'react'
import accountRoutes from './Account/routes'
import termsOfServiceRoutes from './TermsOfService/routes'

const Payments = React.lazy(() => import('./Payments'))
const PayNow = React.lazy(() => import('./Payments/pages/PayNow'))
const AutoPay = React.lazy(() => import('./Payments/pages/AutoPay'))
const Maintenance = React.lazy(() => import('./Maintenance'))
const Lease = React.lazy(() => import('./Lease'))
const Documents = React.lazy(() => import('./Documents'))
const Contact = React.lazy(() => import('./Contact'))
const MaintenanceDetails = React.lazy(
  () => import('./Maintenance/components/MaintenanceDetails'),
)
const RemindersModal = React.lazy(
  () => import('./Maintenance/components/RemindersModal'),
)
const Request = React.lazy(() => import('./Maintenance/components/Request'))
const ScheduleItem = React.lazy(
  () => import('./Maintenance/components/ScheduleItem'),
)
const LoginRedirect = React.lazy(() => import('../components/LoginRedirect'))
const Account = React.lazy(() => import('./Account'))
const NotFound = React.lazy(() => import('./NotFound'))
const Unauthorized = React.lazy(() => import('./Unauthorized'))

const routes: CustomRouteProps[] = [
  {
    path: '/',
    name: 'Home',
    navigation: false,
    isInSideNav: false,
    requireAuth: true,
    element: <DynamicRedirect />,
  },
  {
    path: '/login',
    name: 'LogIn',
    navigation: false,
    isInSideNav: false,
    requireAuth: false,
    element: <Suspense RouteComponent={LoginRedirect} />,
  },
  {
    path: '/payments/pay-now',
    name: 'PayNow',
    navigation: false,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={PayNow} />,
  },
  {
    path: '/payments/auto-pay',
    name: 'PayNow',
    navigation: false,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={AutoPay} />,
  },
  {
    path: '/payments/*',
    name: 'Payments',
    iconType: 'payment',
    isInSideNav: true,
    requireAuth: true,
    element: <Suspense RouteComponent={Payments} />,
  },
  {
    path: '/lease/*',
    name: 'Lease',
    iconType: 'lease',
    isInSideNav: true,
    requireAuth: true,
    element: <Suspense RouteComponent={Lease} />,
  },
  {
    path: '/maintenance/*',
    name: 'Maintenance',
    iconType: 'maintenance',
    isInSideNav: true,
    requireAuth: true,
    element: <Suspense RouteComponent={Maintenance} />,
  },
  {
    path: '/documents/*',
    name: 'Documents',
    iconType: 'documents',
    isInSideNav: true,
    requireAuth: true,
    element: <Suspense RouteComponent={Documents} />,
  },
  {
    path: '/maintenance/maintenance-details',
    name: 'MaintenanceDetails',
    navigation: false,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={MaintenanceDetails} />,
  },
  {
    path: '/maintenance/reminders-modal',
    name: 'RemindersModal',
    navigation: false,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={RemindersModal} />,
  },
  {
    path: '/maintenance/request',
    name: 'Request',
    navigation: false,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={Request} />,
  },
  {
    path: '/maintenance/schedule-item',
    name: 'ScheduleItem',
    navigation: false,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={ScheduleItem} />,
  },
  {
    path: '/account/*',
    name: 'Account',
    iconType: 'account',
    isInSideNav: true,
    requireAuth: true,
    element: <Suspense RouteComponent={Account} />,
  },
  {
    path: '/contact',
    name: 'Contact Us',
    description: 'Find the right contact for your property',
    navigation: true,
    isInSideNav: false,
    requireAuth: true,
    element: <Suspense RouteComponent={Contact} />,
  },
  ...accountRoutes,
  ...termsOfServiceRoutes,
  {
    path: '*',
    name: 'NotFound',
    navigation: false,
    isInSideNav: false,
    requireAuth: false,
    element: <Suspense RouteComponent={NotFound} />,
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    navigation: false,
    isInSideNav: false,
    requireAuth: false,
    element: <Suspense RouteComponent={Unauthorized} />,
  },
]

export default routes
